import { render, staticRenderFns } from "./extra-settings.vue?vue&type=template&id=23dc74ac&scoped=true&"
import script from "./extra-settings.vue?vue&type=script&lang=js&"
export * from "./extra-settings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23dc74ac",
  null
  
)

export default component.exports